import { render, staticRenderFns } from "./AssignedUsers.vue?vue&type=template&id=2f7ac324&scoped=true&"
import script from "./AssignedUsers.vue?vue&type=script&lang=ts&"
export * from "./AssignedUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ac324",
  null
  
)

export default component.exports